define('lq/runtimeErrorHandler',[
    'jquery',
    'underscore',
    'lq',
    'lq/clipboard'
], function ($, _, lq, clipboard) {
    'use strict';
    
    var defaultMessage = 'Please contact the administrator if the problem persists.';

    var createErrorDialog = function (options) {
        var $content = $('<div class="unhandled-error-dialog-content" />');

        var $header = $('<div class="unhandled-error-dialog-header" />')
            .append($('<div class="unhandled-error-dialog-title" />')
                .text('Something went wrong'));

        if (options.devTools) {
            var $devTools = $('<div class="unhandled-error-dev-tools" />');

            if (options.bookmark && options.bookmark.rootMorphId) {
                var bookmark = options.bookmark;

                var queryString = {};

                if (bookmark.morphId)
                    queryString['dropId'] = bookmark.morphId;

                if (bookmark.morphName)
                    queryString['dropName'] = bookmark.morphName;

                var designerPortalUrl = lq.getPortalUrl('rootMorphs/' + bookmark.rootMorphId + '?' + $.param(queryString));

                $devTools
                    .append($('<a />')
                        .attr('href', designerPortalUrl)
                        .attr('target', '_blank')
                        .text('Open in designer'));
            }

            if (options.reference) {
                var errorReportPortalUrl = lq.getPortalUrl('errors/sentry/' + options.reference);

                $devTools
                    .append($('<a />')
                        .attr('href', errorReportPortalUrl)
                        .attr('target', '_blank')
                        .text('View error report'));
            }

            $header.append($devTools);
        }

        $content
            .append($('<div class="unhandled-error-dialog-message" />')
                .text(options.message || defaultMessage));

        if (options.reference) {
            $content.append($('<div />')
                .append($('<span class="unhandled-error-dialog-reference" />')
                    .text('Reference: '))
                .append($('<span />')
                    .text(options.reference))
                .append($('<img class="unhandled-error-dialog-clipboard" />')
                    .attr('title', 'Copy the reference number to the clipboard')
                    .attr('src', require.toUrl('../Images/clipboard.png'))
                    .on('click', function () {
                        clipboard.copy(options.reference);
                    })));
        }

        var $buttons = $('<div class="unhandled-error-dialog-buttons" />')
            .append($('<button class="unhandled-error-dialog-button" />')
                .text(options.buttonLabel)
                .on('click', options.onButtonClicked));

        if (options.allowErrorReporting) {
            var $submitErrorReport = $('<button class="unhandled-error-dialog-button" />')
                .text('Send error report to administrator')
                .on('click', function () {
                    $.ajax({
                        url: lq.getTenantUrl('ErrorReporting/SubmitErrorReport'),
                        type: 'POST',
                        cache: false,
                        data: JSON.stringify({
                            reference: options.reference
                        }),
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        success: function (data, status, response) {
                            $submitErrorReport.remove();
                            options.onErrorSubmitted();
                        },
                        error: $.noop
                    });
                });
            $buttons.append($submitErrorReport);
        }

        $content
            .append($buttons);

        if (options.details) {
            $('<div class="unhandled-error-dialog-details" />')
                .text(options.details)
                .appendTo($content);
        }

        return $('<div class="unhandled-error-layer" />')
            .append($('<div class="unhandled-error-dialog" />')
                .append($header)
                .append($content));
    };

    var RuntimeErrorHandler = function (busyIndicator, application, $container) {
        this.$container = $container;
        this.application = application;
        this.busyIndicator = busyIndicator;
        this.listeners = [];
        this.pageIsUnloading = false;
        this.listenForPageUnloading();
        this.listenForAjaxErrors();
        this.listenForWindowErrors();
    };

    RuntimeErrorHandler.prototype.listenForPageUnloading = function () {
        var self = this;
        $(window).on('unload', function () {
            self.pageIsUnloading = true;
        });
    };

    RuntimeErrorHandler.prototype.listenForAjaxErrors = function () {
        var self = this;
        $(document).ajaxError(function (event, jqxhr, settings) {
            // WHY ignore calls to the designer (when in validation mode) and ignore errors while unloading the page (because aborted requests cause an ajax error)
            if (settings.url.indexOf(lq.getTenantUrl('')) !== 0 || self.pageIsUnloading)
                return;

            // in some cases a null-object can be returned (e.g. when you're disconnected from the internet).
            // this would cause a infinite loop of error logging
            var error = self.getAjaxError(jqxhr) || {};

            if (!self.handleError(error.message)) {

                var $layer = createErrorDialog({
                    allowErrorReporting: self.application.allowErrorReporting,
                    reference: error.referenceId,
                    message: error.message,
                    details: error.details,
                    devTools: error.devTools,
                    bookmark: error.bookmark,
                    buttonLabel: 'Continue',
                    onButtonClicked: function () {
                        $layer.remove();
                        self.$container.css('overflow', '');
                    },
                    onErrorSubmitted: function () {
                        $layer.remove();
                        self.$container.css('overflow', '');
                    }
                });
                
                // for now we're assuming we can recover from these errors
                self.$container
                    .css('overflow', 'hidden')
                    .append($layer);
            }

            self.busyIndicator.forceHide();
        });
    };

    RuntimeErrorHandler.prototype.getAjaxError = function (jqxhr) {
        try {
            return JSON.parse(jqxhr.responseText);
        } catch (e) { }

        return {
            message: jqxhr.responseText
        };
    };

    RuntimeErrorHandler.prototype.listenForWindowErrors = function () {
        var self = this;
        var previousOnerror = window.onerror;

        window.onerror = function (message, file, lineNumber, colno, error) {
            if (file && file.toLowerCase().indexOf('newrelic.com') > -1)
                return true;

            if (previousOnerror)
                previousOnerror(message, file, lineNumber, colno, error);

            var handled = self.handleError(message);
            var stack = self.getStack(error);
            var fullDescription = message + '\n file: ' + file + ' ' + lineNumber;
            var ravenLogger = lq.getRavenLogger();
            var reference = ravenLogger ? ravenLogger.lastEventId() : btoa(new Date().toISOString());

            $.ajax({
                url: lq.getTenantUrl('ErrorReporting/ReportClientError'),
                type: 'POST',
                cache: false,
                data: JSON.stringify({
                    component: lq.getNameOfComponent(),
                    reference: reference,
                    message: fullDescription,
                    file: file,
                    lineNumber: lineNumber,
                    stack: stack
                }),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                success: function(data, status, response) {
                    self.busyIndicator.forceHide();
                },
                error: $.noop
            });

            if (!handled) {
                var $layer = createErrorDialog({
                    reference: reference,
                    allowErrorReporting: self.application.allowErrorReporting,
                    message: self.application.showErrorDetails ? fullDescription : null,
                    details: self.application.showErrorDetails ? stack : null,
                    buttonLabel: 'Reload page',
                    onButtonClicked: function () {
                        window.location.reload();
                    },
                    onErrorSubmitted: $.noop
                });

                self.$container.children().hide();
                // for now we're assuming we cannot recover from these errors
                self.$container.append($layer);
            }

            return true;
        };
    };

    RuntimeErrorHandler.prototype.getStack = function (error) {
        if (!error || !error.stack)
            return 'no stack information available';
        return error.stack;
    };

    RuntimeErrorHandler.prototype.addListener = function (callback) {
        this.listeners.push(callback);
    };

    RuntimeErrorHandler.prototype.removeListener = function (callback) {
        var index = this.listeners.indexOf(callback);
        if (index >= 0)
            this.listeners.splice(index, 1);
    };

    RuntimeErrorHandler.prototype.handleError = function (message) {
        var errorArgs = {
            message: message,
            handled: false
        };

        _.forEach(this.listeners, function (listener) {
            listener(errorArgs);
        });

        return errorArgs.handled;
    };

    return RuntimeErrorHandler;
});
